import { EBlockType, EPopupSubType } from '@/lib/enums';
import { IDailyBonusItem, OfferData } from '@/lib/types';

export const TIME_LEFT_INTERVAL = 1000;

export const processDailyBonusBlocks = (
  popupOffers: OfferData[],
): IDailyBonusItem[] => {
  return popupOffers
    .filter((popup) => popup.subType === EPopupSubType.DAILY_BONUS)
    .sort((a, b) => (a.priority || 0) - (b.priority || 0))
    .map((popup) => ({
      type: EBlockType.DAILY_BONUS,
      offerId: popup.offerId,
      showEvery: popup.showEvery,
      isAllowedToCollect: popup.isAllowedToCollect,
      indexToCollect: popup.indexToCollect,
      productsSequence: popup.productsSequence,
      startOver: popup.startOver,
      priority: popup.priority,
    }));
};

export const calculateNextDate = (dailyBonusItem: IDailyBonusItem, nextAvailableDate: Date): Date => {
  const showEvery = dailyBonusItem?.showEvery;
  const nextDate = nextAvailableDate;

  if (showEvery && showEvery < 1440) {
    const currentDate = new Date();

    return new Date(currentDate.getTime() + showEvery * 60000);
  }

  return nextDate;
};

export const getTimecodeLabel = (timeLeft: number): string => {
  const totalSeconds = Math.round(timeLeft / TIME_LEFT_INTERVAL);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
